var _rect, _circle, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSun(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: 256,
    width: 256
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 128,
    fill: "none",
    r: 60,
    stroke: "#424242",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#424242",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8,
    x1: 128,
    x2: 128,
    y1: 36,
    y2: 16
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#424242",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8,
    x1: 62.9,
    x2: 48.8,
    y1: 62.9,
    y2: 48.8
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#424242",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8,
    x1: 36,
    x2: 16,
    y1: 128,
    y2: 128
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#424242",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8,
    x1: 62.9,
    x2: 48.8,
    y1: 193.1,
    y2: 207.2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#424242",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8,
    x1: 128,
    x2: 128,
    y1: 220,
    y2: 240
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#424242",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8,
    x1: 193.1,
    x2: 207.2,
    y1: 193.1,
    y2: 207.2
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#424242",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8,
    x1: 220,
    x2: 240,
    y1: 128,
    y2: 128
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#424242",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8,
    x1: 193.1,
    x2: 207.2,
    y1: 62.9,
    y2: 48.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSun);
export default __webpack_public_path__ + "static/media/icon-sun.5ffcc90e05ae7bd24fbacc993793f4ba.svg";
export { ForwardRef as ReactComponent };